import { type CreatePackageVariantRequest, type PackageVariantOut } from '@utazzo/shared';

export interface TravellerOptionRow {
  id?: string;
  name: string;
  priceRupees: string;
  discountRupees: string;
}

const moneyStr = (n: number): string => String(Math.round(n * 100) / 100);

/** Return date for an N-day trip: departure on day 1, return on day N. */
export const computeReturnDate = (departureDate: string, numberOfDays: number): string => {
  const d = new Date(`${departureDate}T12:00:00`);
  d.setDate(d.getDate() + Math.max(0, numberOfDays - 1));
  return d.toISOString().slice(0, 10);
};

export const variantToTravellerRow = (
  v: PackageVariantOut | CreatePackageVariantRequest,
): TravellerOptionRow => {
  const name = v.name;
  if (v.strikePrice) {
    const disc = Math.max(0, Number(v.strikePrice) - Number(v.price));
    return {
      ...('id' in v ? { id: v.id } : {}),
      name,
      priceRupees: v.strikePrice,
      discountRupees: disc > 0 ? moneyStr(disc) : '',
    };
  }
  return {
    ...('id' in v ? { id: v.id } : {}),
    name,
    priceRupees: v.price,
    discountRupees: '',
  };
};

export const travellerRowToVariant = (row: TravellerOptionRow): CreatePackageVariantRequest => {
  const total = row.priceRupees.trim();
  const discStr = row.discountRupees.trim();
  const disc = discStr === '' ? 0 : Number(discStr);
  const orig = Number(total);
  if (disc > 0 && Number.isFinite(orig)) {
    return {
      name: row.name.trim(),
      price: moneyStr(Math.max(0, orig - disc)),
      strikePrice: total,
    };
  }
  return {
    name: row.name.trim(),
    price: total,
    strikePrice: null,
  };
};

export const emptyTravellerRow = (): TravellerOptionRow => ({
  name: '',
  priceRupees: '',
  discountRupees: '',
});
